import { IBrandBilling } from "./brandBilling";
import { IBrand } from "./brandUser";
import { IBrief } from "./brief";
import {
  BillingEntity,
  BriefCampaignInf,
  FinanceBasePayoutFlags,
  FinanceGstPayoutFlags,
  FinanceInvoiceFlags,
  IInvoice,
} from "./briefCampains";
import { IBriefInfluencerV2, ICost, ICreatedBy } from "./briefInfluencerV2";

import { IPagination } from "./user";

export interface IFinanceApprovalLot {
  _id: string;
  briefId: string;
  brief: IBrief;
  brandId: string;
  brand: IBrand;
  purchaseProof?: string;
  lotNumber: number;
  purchaseItems: IFinanceApprovalLotItem[];

  createdAt: Date;
  updatedAt: Date;

  updatedBy: ICreatedBy;
  updatedByModelName: string;
  updatedByType: string;

  createdBy: ICreatedBy;
  createdByModelName: string;
  createdByType: string;
  status: purchaseLotStatus;
  influencerCost: number;
  serviceCharge: number;
  brandCost: number;
  revenue: number;
  revenuePercentage: number;
  brandBilling: IBrandBilling;
  remarks?: string;
}

export interface IFinanceApprovalLotItem {
  briefInfluencerId: string;
  briefInfluencer: IBriefInfluencerV2;

  status: purchaseLotStatus;
  rejectReason?: string;
  influencerCost?: ICost;
  brandCost?: ICost;
  approvedBy?: ICreatedBy;
  approvedByModelName?: string;
  approvedByType?: string;
  approvedAt?: Date;

  rejectedBy?: ICreatedBy;
  rejectedByModelName?: string;
  rejectedByType?: string;
  rejectedAt?: Date;
  _id: string;
}

export enum purchaseLotStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
}

export interface IFinanceApprovalLotsResponse {
  data: IFinanceApprovalLot[];
  pagination: IPagination;
}

export interface IFinanceApprovalLotsRequest {
  limit: number;
  pageNo: number;
  searchQuery?: string;
  status?: purchaseLotStatus[];
}

export interface IGstInvoice
  extends Omit<
    IInvoice,
    "vendorBilling" | "influencer" | "briefInfluencer" | "campaignInfluencer"
  > {
  vendorBilling: BillingEntity;
  campaignInfluencer: BriefCampaignInf;
  gstStatus: string;
  gstPaymentStatus: string;
  gstPaymentLeft?: number;
  gstFilledStatusByVendor?: string;
  campaignInfluencerFinanceFlags?: BriefCampaignInf["financeFlags"];
  invoiceFinanceFlags?: {
    gstPayout?: {
      status: FinanceGstPayoutFlags;
      paid: number;
      total: number;
      left: number;
    };
  };
}
export interface IGstInvoices {
  data: IGstInvoice[];
  pagination: IPagination;
}
export type IGstInvoicesRequest = Partial<{
  invoiceDate: Partial<{ from: string; to: string }>;
  searchQuery: string;
  gstFilledStatusByVendor?: GstFilledStatusByVendor[];
  campaignInfluencerFinanceFlags: {
    invoice?: {
      statuses: FinanceInvoiceFlags[];
    };
    basePayout?: {
      statuses?: FinanceBasePayoutFlags[];
    };
    gstPayout?: {
      statuses?: FinanceGstPayoutFlags[];
    };
  };
  invoiceFinanceFlags?: {
    basePayout?: {
      statuses?: FinanceBasePayoutFlags[];
    };
    gstPayout?: {
      statuses?: FinanceGstPayoutFlags[];
    };
  };
}>;

export enum GstFilledStatusByVendor {
  Pending = "Pending",
  "Input-Received" = "Input-Received",
}
export interface IGstFileUploadRequest {
  invoiceDate: {
    from: string;
    to: string;
  };
  inputFileUrl: string;
}

export interface IBulkPaymentRequest {
  campaignInfluencerId: string;
  remarks?: string;
  amount: number;
  linkedInvoiceId: string;
  subType: "Gst";
}
